import React, { useContext } from 'react';
import { View } from 'react-native';
import { useTheme, Icon } from '@rneui/themed';
import PropTypes from 'prop-types';
import GivingContext from '../../../contexts/Giving';
import LayoutContext from '../../../contexts/Layout';

const MultipleCardIcons = () => {
    const { state } = useContext(GivingContext);
    const {
        layout: {
            dimensions: { width }
        }
    } = useContext(LayoutContext);
    const { theme } = useTheme();
    const ACTIVE_COLOR = theme?.colors?.verydarkgrey;
    const ACTIVE_SIZE = width <= 480 ? 12 : 32;
    const INACTIVE_COLOR = theme?.colors?.grey3;
    const INACTIVE_SIZE = width <= 480 ? 10 : 28;

    const CreditCardIcon = props => {
        const name = props?.name;
        const color = state.cartDetails.paymentInfo?.ccType?.equals(name) ? ACTIVE_COLOR : INACTIVE_COLOR;
        const size = state.cartDetails.paymentInfo?.ccType?.equals(name) ? ACTIVE_SIZE : INACTIVE_SIZE;

        return <Icon focusable={false} name={name} size={size} color={color} type='font-awesome-5' containerStyle={{ padding: 1 }} tabIndex={-1} />;
    };

    return (
        <View
            focusable={false}
            style={{
                alignItems: 'center',
                marginBottom: '12pt',
                paddingRight: theme?.margins?.gutter,
                width: '33%'
            }}
            tabIndex={-1}
        >
            <View
                focusable={false}
                style={{
                    alignItems: 'center',
                    flexDirection: 'row',
                    justifyContent: 'space-evenly',
                    width: '100%'
                }}
                tabIndex={-1}
            >
                <CreditCardIcon name='cc-visa' />
                <CreditCardIcon name='cc-mastercard' />
                <CreditCardIcon name='cc-discover' />
                <CreditCardIcon name='cc-amex' />
            </View>
        </View>
    );
};

MultipleCardIcons.propTypes = {
    name: PropTypes.string
};

export default MultipleCardIcons;
